import { useState } from 'react';

import { useGenericModal } from '..';
import {
  DeleteLiveAgentPlatformModal,
  DeleteLiveAgentPlatformModalProps,
} from './delete-live-agent-platform-modal';

type Env = 'live' | 'sandbox';

export const useDeleteLiveAgentPlatformModal = (
  props?: Partial<DeleteLiveAgentPlatformModalProps>
) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const [connectionId, setConnectionId] = useState<string | undefined>();
  const [connectionName, setConnectionName] = useState('');
  const [env, setEnv] = useState<Env>('live');

  const modalComponent = (
    <DeleteLiveAgentPlatformModal
      testId={props?.testId}
      modalRef={modalRef}
      onClose={closeModal}
      connectionId={connectionId}
      connectionName={connectionName}
      env={env}
    />
  );

  const openDeleteModal = (options: {
    connectionId: string;
    connectionName: string;
    env: Env;
  }) => {
    setConnectionId(options.connectionId);
    setConnectionName(options.connectionName);
    setEnv(options.env);
    openModal();
  };

  return {
    modalRef,
    openModal: openDeleteModal,
    closeModal,
    deleteLiveAgentPlatformModal: modalComponent,
  };
};
